import isEmpty from 'lodash/isEmpty'

/** The deterministic ids of the two reserved categories: per tenant, or the tenant-free pair when there is no tenant id. */
export function getReservedBlogCategoryIds(tenantId?: string | null): { uncategorized: string; whatsNew: string } {
  const suffix = isEmpty(tenantId) ? '' : `-${tenantId}`

  return { uncategorized: `category-uncategorized${suffix}`, whatsNew: `category-whats-new${suffix}` }
}
